import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=5afa7546&scoped=true"
import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=5afa7546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa7546",
  null
  
)

export default component.exports